import React, {useEffect, useState} from 'react'
import {useAppDispatch, useAppSelector} from "../redux";
import {getAuthUser} from "../redux/slices/account";

export default function Account() {
    const {user, token} = useAppSelector(state => state.account)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (token) {
            dispatch(getAuthUser({ token }));
        }
    }, [token]);

    if (!token) {
        return <div>Something went wrong, you should not see this.</div>
    }

    return (
        <div className="isolate overflow-hidden">
            <div className="flow-root pb-16 pt-24 sm:pt-32 lg:pb-0">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="relative z-10">
                        <h2 className="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight text-white">
                            Hello, {user?.email}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    )
}
